import { Badge } from "@nfp-tracker/components";
import { cn } from "@nfp-tracker/utils";

type NewBadgeProps = {
  className?: string;
  /** `dot` is a compact indicator for tight spots like nav items and collapsed sidebars. */
  variant?: "badge" | "dot";
  label?: string;
};

/** Small "New" marker for what's-new items (see constants/whatsNew.ts). */
export const NewBadge = ({ className, variant = "badge", label = "New" }: NewBadgeProps) => {
  if (variant === "dot") {
    return (
      <span
        role="img"
        aria-label={label}
        className={cn("inline-block h-2 w-2 shrink-0 rounded-full bg-fuchsia-500", className)}
      />
    );
  }
  return (
    <Badge
      className={cn(
        "border-transparent bg-gradient-to-r from-primary to-fuchsia-500 px-2 py-0 text-[11px] text-primary-foreground hover:from-primary hover:to-fuchsia-500",
        className
      )}
    >
      {label}
    </Badge>
  );
};
